import React, { useCallback, useEffect, useState } from 'react';
import { Accordion, AccordionPanel } from 'flowbite-react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { Link, useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import { navLinksData } from '../../data/navLinks';
import { logout } from '../../features/authSlice';
import { menucontrol } from '../../features/togglebuttonSlice';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';

const AdminMenu = ({ isAdmin, isAuthenticated }) => {
  const isActive = useSelector((state) => state.toggle.isActive);
  const [mobileTopHeader, setMobileTopHeader] = useState(false);
  const [isSubmenuOpen, setIsSubmenuOpen] = useState(false);

  const { t } = useTranslation();
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const handleLogout = useCallback(() => {
    toast.success(t('msg_logoutSuccess'));
    dispatch(logout());
    'isHome', true;
    localStorage.setItem;
    dispatch(menucontrol(true));
    window.location.href = '/managementLogin';
  }, [dispatch, navigate, t]);

  const handleClick = () => {
    localStorage.setItem('isHome', true);
    dispatch(menucontrol(true));
    window.location.href = '/';
  };
  useEffect(() => {
    dispatch(menucontrol(false));
  }, []);

  const handleCloseClick = () => {
    setMobileTopHeader(false);
    // setIsSidebarOpen(false)
  };
  const handleHamburgerClick = () => {
    setMobileTopHeader(true);
    // setIsSidebarOpen(true)
  };

  const toggleSubmenu = () => {
    setIsSubmenuOpen(true);

    setTimeout(() => {
      setIsSubmenuOpen(false);
    }, 300);
  };
  return (
    <>
      {/* <Header /> */}
      <header style={{ zIndex: 9, position: 'relative' }}>
        <nav
          data-aos="fade-down"
          data-aos-easing="linear"
          data-aos-duration="1500"
          className="bg-white align-middle items-center  w-full z-20 "
        >
          <div className={`bg-gray-200 w-full xl:flex relative  sm:z-2  top-0 start-0`}>
            <Link
              onClick={handleClick}
              className={`flex items-center  rtl:space-x-reverse ${isActive ? 'mx-5  sm:ps-12' : 'mx-5 sm:ps-12'}`}
            >
              <div
                data-aos="fade-down"
                data-aos-easing="linear"
                data-aos-duration="2500"
                className={`absolute items-center flex  xl:bg-gray-50 pt-2 lg:pt-8 xl:pb-6 mx-3 xl:rounded-b-3xl z-20 lg:px-5 top-0 justify-center`}
              >
                <img src="/assets/logo.png" className="lg:h-15 xl:h-20 h-10" alt="SHJC" />
              </div>
            </Link>
            <div
              className={`items-center bg-slate-200 w-full p-2 xl:justify-between  flex xl:flex ${isActive ? ' flex-row justify-end' : ' flex-row justify-end'}`}
            >
              <button
                id="triggerEl"
                type="button"
                onClick={handleHamburgerClick}
                className={`flex  justify-center items-center w-10 h-10 xl:hidden z-20 text-sm text-gray-500 rounded-lg absolute hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-gray-200 ${isActive ? 'right-0' : 'left-0 '}`}
                aria-expanded="false"
              >
                <span className="sr-only">Open main menu</span>
                <svg className="w-5 h-5" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 17 14">
                  <path
                    stroke="currentColor"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                    d="M1 1h15M1 7h15M1 13h15"
                  />
                </svg>
              </button>
              <div>
                <ul
                  className={`xl:flex hover:text-customgreen hidden flex-col max-[600px]:justify-end items-center text-sm  md:p-0 font-medium rounded-lg bg-gray-200  md:mt-0  md:bg-gray-200 ${isActive ? 'space-x-4   flex-row  ms-6' : ' ms-4 flex-row space-x-1'}`}
                >
                  <li className={`text-customgreen hover:text-customgreen mx-1`}>
                    <Link to={'/admin'} className="hover:text-customgreen">
                      {t('home')}
                    </Link>
                  </li>

                  <div className="text-customgreen ">
                    <li className="dropdown  cursor-pointer  ">
                      {t('nav_cms')}
                      <KeyboardArrowDownIcon />

                      <ul className={`dropdown_menu  `}>
                        <Link
                          to={'/readPressRelease'}
                          className="cursor-pointer relative  z-40 whitespace-nowrap flex flex-col hover:text-customgreen "
                        >
                          <li className={`sub_dropdown_item-1 ${isSubmenuOpen && 'closed'} `} onClick={toggleSubmenu}>
                            {t('navItem_pressRelease')}
                          </li>
                        </Link>
                        <hr className="text-gray-400" />
                        <Link
                          to={'/readPhotoGallery'}
                          className="cursor-pointer relative  z-40 whitespace-nowrap flex flex-col hover:text-customgreen "
                        >
                          <li className={`sub_dropdown_item-2 ${isSubmenuOpen && 'closed'} `} onClick={toggleSubmenu}>
                            {t('navItem_photoGallery')}
                          </li>
                        </Link>
                        <hr className="text-gray-400" />
                        <Link
                          to={'/readInfographic'}
                          className="cursor-pointer relative  z-40 whitespace-nowrap flex flex-col hover:text-customgreen "
                        >
                          <li className={`sub_dropdown_item-3 ${isSubmenuOpen && 'closed'} `} onClick={toggleSubmenu}>
                            {t('navItem_infographic')}
                          </li>
                        </Link>
                        <hr className="text-gray-400" />
                        <Link
                          to={`/readSuccessStory`}
                          className="cursor-pointer relative  z-40 whitespace-nowrap flex flex-col hover:text-customgreen "
                        >
                          <li className={`sub_dropdown_item-3 ${isSubmenuOpen && 'closed'} `} onClick={toggleSubmenu}>
                            {t('navItem_successStory')}
                          </li>
                        </Link>
                        <hr className="text-gray-400" />
                        <Link
                          to={`/readVideoGallery`}
                          className="cursor-pointer relative  z-40 whitespace-nowrap flex flex-col hover:text-customgreen "
                        >
                          <li className={`sub_dropdown_item-3 ${isSubmenuOpen && 'closed'} `} onClick={toggleSubmenu}>
                            {t('navItem_videoGallery')}
                          </li>
                        </Link>
                        <hr className="text-gray-400" />
                        <Link
                          to={'/downloadcenter'}
                          className="cursor-pointer relative  z-40 whitespace-nowrap flex flex-col hover:text-customgreen "
                        >
                          <li className={`sub_dropdown_item-3 ${isSubmenuOpen && 'closed'} `} onClick={toggleSubmenu}>
                            {t('Download Center')}
                          </li>
                        </Link>
                        <hr className="text-gray-400" />
                        <Link
                          to={'/smsmenulist'}
                          className="cursor-pointer relative  z-40 whitespace-nowrap flex flex-col hover:text-customgreen "
                        >
                          <li className={`sub_dropdown_item-3 ${isSubmenuOpen && 'closed'} `}>{t('CMS Project')}</li>
                        </Link>
                        <hr className="text-gray-400" />
                        <Link
                          to={'/bannerDashboard'}
                          className="cursor-pointer relative  z-40 whitespace-nowrap flex flex-col hover:text-customgreen "
                        >
                          <li className={`sub_dropdown_item-3 ${isSubmenuOpen && 'closed'} `}>
                            {t('Sliders Dashboard')}
                          </li>
                        </Link>
                      </ul>
                    </li>
                  </div>
                  <div className="text-customgreen ">
                    <li className="dropdown  cursor-pointer  ">
                      {t('Goodwill Ambassador')}
                      <KeyboardArrowDownIcon />

                      <ul className={`dropdown_menu  `}>
                        <Link
                          to={'/GWARegisterApprovalList'}
                          className="cursor-pointer relative  z-40 whitespace-nowrap flex flex-col hover:text-customgreen "
                        >
                          <li className={`sub_dropdown_item-1 ${isSubmenuOpen && 'closed'} `} onClick={toggleSubmenu}>
                            {t('Register Approval List')}
                          </li>
                        </Link>
                        <hr className="text-gray-400" />
                        <Link
                          to={'/GWAProjectApprovalList'}
                          className="cursor-pointer relative  z-40 whitespace-nowrap flex flex-col hover:text-customgreen "
                        >
                          <li className={`sub_dropdown_item-2 ${isSubmenuOpen && 'closed'} `} onClick={toggleSubmenu}>
                            {t('Project Approval List')}
                          </li>
                        </Link>
                        <hr className="text-gray-400" />
                        <Link
                          to={'/GWAManageList'}
                          className="cursor-pointer relative  z-40 whitespace-nowrap flex flex-col hover:text-customgreen "
                        >
                          <li className={`sub_dropdown_item-3 ${isSubmenuOpen && 'closed'} `} onClick={toggleSubmenu}>
                            {t('Manage List')}
                          </li>
                        </Link>
                      </ul>
                    </li>
                  </div>
                  <div className="text-customgreen ">
                    <li className="dropdown  cursor-pointer  ">
                      {t('Service For Dead')}
                      <KeyboardArrowDownIcon />

                      <ul className={`dropdown_menu  `}>
                        <Link
                          to={'/SDProjectApprovalList'}
                          className="cursor-pointer relative  z-40 whitespace-nowrap flex flex-col hover:text-customgreen "
                        >
                          <li className={`sub_dropdown_item-1 ${isSubmenuOpen && 'closed'} `} onClick={toggleSubmenu}>
                            {t('Project Approval List')}
                          </li>
                        </Link>
                        <hr className="text-gray-400" />
                        <Link
                          to={'/SDPublishProjectList'}
                          className="cursor-pointer relative  z-40 whitespace-nowrap flex flex-col hover:text-customgreen "
                        >
                          <li className={`sub_dropdown_item-2 ${isSubmenuOpen && 'closed'} `} onClick={toggleSubmenu}>
                            {t('Publish Project List')}
                          </li>
                        </Link>
                        <hr className="text-gray-400" />
                        <Link
                          to={'/SDReportList'}
                          className="cursor-pointer relative  z-40 whitespace-nowrap flex flex-col hover:text-customgreen "
                        >
                          <li className={`sub_dropdown_item-3 ${isSubmenuOpen && 'closed'} `} onClick={toggleSubmenu}>
                            {t('Service For Dead Report List')}
                          </li>
                        </Link>
                      </ul>
                    </li>
                  </div>
                  <div className="text-customgreen ">
                    <li className="dropdown  cursor-pointer">
                      {t('Idea Suggestion')}
                      <KeyboardArrowDownIcon />

                      <ul className={`dropdown_menu  `}>
                        <Link
                          to={'/IdeaSuggestionList'}
                          className="cursor-pointer relative  z-40 whitespace-nowrap flex flex-col hover:text-customgreen "
                        >
                          <li className={`sub_dropdown_item-1 ${isSubmenuOpen && 'closed'} `} onClick={toggleSubmenu}>
                            {t('Idea Suggestion List')}
                          </li>
                        </Link>
                      </ul>
                    </li>
                  </div>

                  <li className="text-customgreen ">
                    <li className="dropdown  cursor-pointer">
                      {t('Service For Gift')}
                      <KeyboardArrowDownIcon />

                      <ul className={`dropdown_menu  `}>
                        <Link
                          to={'/gifts'}
                          className="cursor-pointer relative  z-40 whitespace-nowrap flex flex-col hover:text-customgreen "
                        >
                          <li className={`sub_dropdown_item-1 ${isSubmenuOpen && 'closed'} `} onClick={toggleSubmenu}>
                            {t('Gift Service List')}
                          </li>
                        </Link>
                      </ul>
                    </li>
                  </li>
                  {isAuthenticated && (
                    <>
                      {navLinksData.map((el, i) => (
                        <div className="text-customgreen  " key={i}>
                          {el.children && (
                            <li className="dropdown  cursor-pointer">
                              {t(`${el.name}`)}
                              <KeyboardArrowDownIcon />

                              <ul className={`dropdown_menu  `}>
                                {el.children.map((ele, index) =>
                                  isAdmin === ele.isAdmin && !ele.ishidden ? (
                                    <>
                                      <Link
                                        to={ele.link}
                                        key={index}
                                        className="cursor-pointer relative  z-40 whitespace-nowrap flex flex-col hover:text-customgreen "
                                      >
                                        <li
                                          className={`sub_dropdown_item-${index + 1} ${isSubmenuOpen && 'closed'} `}
                                          onClick={toggleSubmenu}
                                        >
                                          {t(`${ele.name}`)}
                                        </li>
                                      </Link>
                                      <hr className="text-gray-400" />
                                    </>
                                  ) : null,
                                )}
                              </ul>
                            </li>
                          )}
                        </div>
                      ))}
                    </>
                  )}
                  <div className="text-customgreen ">
                    <li className="dropdown  cursor-pointer">
                      {t('Reports')}
                      <KeyboardArrowDownIcon />

                      <ul className={`dropdown_menu  `}>
                        <Link
                          to={'/GetSDReportFilterList'}
                          className="cursor-pointer relative  z-40 whitespace-nowrap flex flex-col hover:text-customgreen "
                        >
                          <li className={`sub_dropdown_item-1 ${isSubmenuOpen && 'closed'} `} onClick={toggleSubmenu}>
                            {t('SD Report')}
                          </li>
                        </Link>
                        <hr className="text-gray-400" />
                        <Link
                          to={'/GetGWAReportFilterList'}
                          className="cursor-pointer relative  z-40 whitespace-nowrap flex flex-col hover:text-customgreen "
                        >
                          <li className={`sub_dropdown_item-1 ${isSubmenuOpen && 'closed'} `} onClick={toggleSubmenu}>
                            {t('GWA Report')}
                          </li>
                        </Link>
                        <hr className="text-gray-400" />
                        <Link
                          to={'/GetGWAServiceReportFilterList'}
                          className="cursor-pointer relative  z-40 whitespace-nowrap flex flex-col hover:text-customgreen "
                        >
                          <li className={`sub_dropdown_item-1 ${isSubmenuOpen && 'closed'} `} onClick={toggleSubmenu}>
                            {t('GWA Service Report')}
                          </li>
                        </Link>
                        <hr className="text-gray-400" />
                        <Link
                          to={'/GetCampaignReportFilterList'}
                          className="cursor-pointer relative  z-40 whitespace-nowrap flex flex-col hover:text-customgreen "
                        >
                          <li className={`sub_dropdown_item-1 ${isSubmenuOpen && 'closed'} `} onClick={toggleSubmenu}>
                            {t('Campaign Report')}
                          </li>
                        </Link>
                        <hr className="text-gray-400" />
                        <Link
                          to={'/GetServiceForYouReportFilterList'}
                          className="cursor-pointer relative  z-40 whitespace-nowrap flex flex-col hover:text-customgreen "
                        >
                          <li className={`sub_dropdown_item-1 ${isSubmenuOpen && 'closed'} `} onClick={toggleSubmenu}>
                            {t('Service You Report')}
                          </li>
                        </Link>
                        <hr className="text-gray-400" />
                        <Link
                          to={'/EPVolunteerReportList'}
                          className="cursor-pointer relative  z-40 whitespace-nowrap flex flex-col hover:text-customgreen "
                        >
                          <li className={`sub_dropdown_item-1 ${isSubmenuOpen && 'closed'} `} onClick={toggleSubmenu}>
                            {t('Volunteer Report List')}
                          </li>
                        </Link>
                        <hr className="text-gray-400" />
                        <Link
                          to={'/EPUserReportList'}
                          className="cursor-pointer relative  z-40 whitespace-nowrap flex flex-col hover:text-customgreen "
                        >
                          <li className={`sub_dropdown_item-1 ${isSubmenuOpen && 'closed'} `} onClick={toggleSubmenu}>
                            {t('User Profile Report List')}
                          </li>
                        </Link>
                        <hr className="text-gray-400" />
                        <Link
                          to={'/LoginLogsReportList'}
                          className="cursor-pointer relative  z-40 whitespace-nowrap flex flex-col hover:text-customgreen "
                        >
                          <li className={`sub_dropdown_item-1 ${isSubmenuOpen && 'closed'} `} onClick={toggleSubmenu}>
                            {t('Login Logs Report')}
                          </li>
                        </Link>
                        <hr className="text-gray-400" />
                        <Link
                          to={'/PaymentReport'}
                          className="cursor-pointer relative  z-40 whitespace-nowrap flex flex-col hover:text-customgreen "
                        >
                          <li className={`sub_dropdown_item-1 ${isSubmenuOpen && 'closed'} `} onClick={toggleSubmenu}>
                            {t('Donation Report')}
                          </li>
                        </Link>
                      </ul>
                    </li>
                  </div>
                </ul>
              </div>

              <div className={`lg:flex ${isActive ? 'mx-2  ' : 'mx-2'} `}>
                <ul>
                  <li className="text-customgreen  ">
                    {/* <button
                      type="button"
                      onClick={handleLogout}
                      className="text-xs font-medium text-center inline-flex items-center  bg-transparent  text-customorange"
                    >
                      <svg
                        className="w-5 h-6 text-customorange me-2"
                        aria-hidden="true"
                        xmlns="http://www.w3.org/2000/svg"
                        fill="currentColor"
                        viewBox="0 0 24 24"
                      >
                        <path d="M14 12h-4v-12h4v12zm4.213-10.246l-1.213 1.599c2.984 1.732 5 4.955 5 8.647 0 5.514-4.486 10-10 10s-10-4.486-10-10c0-3.692 2.016-6.915 5-8.647l-1.213-1.599c-3.465 2.103-5.787 5.897-5.787 10.246 0 6.627 5.373 12 12 12s12-5.373 12-12c0-4.349-2.322-8.143-5.787-10.246z" />
                      </svg>
                    </button> */}
                    <button
                      type="button"
                      onClick={handleLogout}
                      className={` text-xs font-medium text-center inline-flex items-center  bg-transparent  text-customorange`}
                    >
                      <svg
                        className="h-6 w-5 text-customorange"
                        aria-hidden="true"
                        xmlns="http://www.w3.org/2000/svg"
                        fill="currentColor"
                        viewBox="0 0 24 24"
                      >
                        <path d="M14 12h-4v-12h4v12zm4.213-10.246l-1.213 1.599c2.984 1.732 5 4.955 5 8.647 0 5.514-4.486 10-10 10s-10-4.486-10-10c0-3.692 2.016-6.915 5-8.647l-1.213-1.599c-3.465 2.103-5.787 5.897-5.787 10.246 0 6.627 5.373 12 12 12s12-5.373 12-12c0-4.349-2.322-8.143-5.787-10.246z" />
                      </svg>
                    </button>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </nav>
      </header>
      {/* <AdminBanner /> */}
      {mobileTopHeader && (
        <div
          className={`xl:hidden  text-white maindiv fixed top-0 z-30  ${isActive ? 'right-0' : 'left-0'} h-screen w-2/3 bg-green-50 overflow-y-auto scrollbar-thin scrollbar-thumb-green-600 scrollbar-track-gray-200`}
        >
          <div className={` flex justify-end p-2 mx-2 z-40 top-0 ${isActive ? '' : ''} `}>
            <button
              onClick={handleCloseClick}
              className="  text-customgreen rounded-md hover:bg-customgreen hover:text-white"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
                strokeWidth={1.5}
                stroke="currentColor"
                className="size-6"
              >
                <path strokeLinecap="round" strokeLinejoin="round" d="M6 18 18 6M6 6l12 12" />
              </svg>
            </button>
          </div>

          <div className={` my-2  mx-auto w-4/5`}>
            <div
              className={`xl:hidden flex-col items-center  font-medium rounded-lg bg-green-50  md:bg-gray-200 ${isActive ? 'space-x-4   flex-row' : ' flex-row  space-x-0'}`}
            >
              <ul>
                <Accordion collapseAll className=" bg-green-50 text-center  !border-none ">
                  <li className={`${isActive ? 'text-right' : 'text-left'}  `}>
                    <Link
                      to={'/admin'}
                      onClick={handleCloseClick}
                      className="accordion-heading dark:divide-gray-0 p-2 divide-y-0 divide-gray-0 focus:ring-gray-50 dark:focus:ring-gray-0 text-customgreen hover:text-customgreen"
                    >
                      {t('home')}
                    </Link>
                  </li>

                  <AccordionPanel className="">
                    <Accordion.Title className="accordion-heading hover:text-customgreen dark:divide-gray-0 p-2 divide-y-0 divide-gray-0 focus:ring-gray-50 dark:focus:ring-gray-0 text-customgreen ">
                      {t('nav_cms')}
                    </Accordion.Title>
                    <Accordion.Content className="p-2 bg-white text-center">
                      <ul  className={`${isActive ? 'text-right' : 'text-left'}  `}>
                        <li className="accordion-children focus:ring-gray-50 dark:focus:ring-gray-0 text-customgreen ">
                          {isAdmin && (
                            <Link
                              className="hover:text-customgreen"
                              onClick={handleCloseClick}
                              to={'/readPressRelease'}
                            >
                              {t('navItem_pressRelease')}
                            </Link>
                          )}
                        </li>
                        <li className="accordion-children focus:ring-gray-50 dark:focus:ring-gray-0 text-customgreen ">
                          {isAdmin && (
                            <Link
                              className="hover:text-customgreen"
                              onClick={handleCloseClick}
                              to={'/readPhotoGallery'}
                            >
                              {t('navItem_photoGallery')}
                            </Link>
                          )}
                        </li>
                        <li className="accordion-children focus:ring-gray-50 dark:focus:ring-gray-0 text-customgreen ">
                          {isAdmin && (
                            <Link className="hover:text-customgreen" onClick={handleCloseClick} to={'/readInfographic'}>
                              {t('navItem_infographic')}
                            </Link>
                          )}
                        </li>
                        <li className="accordion-children focus:ring-gray-50 dark:focus:ring-gray-0 text-customgreen ">
                          {isAdmin && (
                            <Link
                              className="hover:text-customgreen"
                              onClick={handleCloseClick}
                              to={'/readSuccessStory'}
                            >
                              {t('navItem_successStory')}
                            </Link>
                          )}
                        </li>
                        <li className="accordion-children focus:ring-gray-50 dark:focus:ring-gray-0 text-customgreen ">
                          {isAdmin && (
                            <Link
                              className="hover:text-customgreen"
                              onClick={handleCloseClick}
                              to={'/readVideoGallery'}
                            >
                              {t('navItem_videoGallery')}
                            </Link>
                          )}
                        </li>
                        <li className="accordion-children focus:ring-gray-50 dark:focus:ring-gray-0 text-customgreen ">
                          {isAdmin && (
                            <Link className="hover:text-customgreen" onClick={handleCloseClick} to={'/downloadcenter'}>
                              {t('Download Center')}
                            </Link>
                          )}
                        </li>
                        <li className="accordion-children focus:ring-gray-50 dark:focus:ring-gray-0 text-customgreen ">
                          <Link
                            to={'/smsmenulist'}
                            onClick={handleCloseClick}
                            className="hover:text-customgreen dark:divide-gray-0 divide-y-0 divide-gray-0 focus:ring-gray-50 dark:focus:ring-gray-0 text-customgreen "
                          >
                            {t('CMS Project')}
                          </Link>
                        </li>
                        <li className="accordion-children focus:ring-gray-50 dark:focus:ring-gray-0 text-customgreen ">
                          <Link
                            to={'/bannerDashboard'}
                            onClick={handleCloseClick}
                            className="hover:text-customgreen dark:divide-gray-0 divide-y-0 divide-gray-0 focus:ring-gray-50 dark:focus:ring-gray-0 text-customgreen "
                          >
                            {t('Sliders Dashboard')}
                          </Link>
                        </li>
                      </ul>
                    </Accordion.Content>
                  </AccordionPanel>

                  <AccordionPanel>
                    <Accordion.Title className="accordion-heading hover:text-customgreen dark:divide-gray-0 p-2 divide-y-0 divide-gray-0 focus:ring-gray-50 dark:focus:ring-gray-0 text-customgreen ">
                      {t('Goodwill Ambassador')}
                    </Accordion.Title>
                    <Accordion.Content className="p-2 bg-white text-center">
                      <ul  className={`${isActive ? 'text-right' : 'text-left'}  `}>
                        <li className="accordion-children focus:ring-gray-50 dark:focus:ring-gray-0 text-customgreen ">
                          {isAdmin && (
                            <Link
                              className="hover:text-customgreen"
                              to={'/GWARegisterApprovalList'}
                              onClick={handleCloseClick}
                            >
                              {t('Register Approval List')}
                            </Link>
                          )}
                        </li>
                        <li className="accordion-children focus:ring-gray-50 dark:focus:ring-gray-0 text-customgreen ">
                          {' '}
                          <Link
                            className="hover:text-customgreen"
                            to={'/GWAProjectApprovalList'}
                            onClick={handleCloseClick}
                          >
                            {t('Project Approval List')}
                          </Link>
                        </li>
                        <li className="accordion-children focus:ring-gray-50 dark:focus:ring-gray-0 text-customgreen ">
                          {' '}
                          {isAdmin && (
                            <Link className="hover:text-customgreen" to={'/GWAManageList'} onClick={handleCloseClick}>
                              {t('Manage List')}
                            </Link>
                          )}
                        </li>
                      </ul>
                    </Accordion.Content>
                  </AccordionPanel>

                  <AccordionPanel>
                    <Accordion.Title className="accordion-heading hover:text-customgreen dark:divide-gray-0 p-2 divide-y-0 divide-gray-0 focus:ring-gray-50 dark:focus:ring-gray-0 text-customgreen ">
                      {t('Service For Dead')}
                    </Accordion.Title>
                    <Accordion.Content className="p-2 bg-white text-center">
                      <ul  className={`${isActive ? 'text-right' : 'text-left'}  `}>
                        <li className="accordion-children focus:ring-gray-50 dark:focus:ring-gray-0 text-customgreen ">
                          {isAdmin && (
                            <Link
                              className="hover:text-customgreen"
                              to={'/SDProjectApprovalList'}
                              onClick={handleCloseClick}
                            >
                              {t('Project Approval List')}
                            </Link>
                          )}
                        </li>
                        <li className="accordion-children focus:ring-gray-50 dark:focus:ring-gray-0 text-customgreen ">
                          {' '}
                          <Link
                            className="hover:text-customgreen"
                            to={'/SDPublishProjectList'}
                            onClick={handleCloseClick}
                          >
                            {t('Publish Project List')}
                          </Link>
                        </li>
                        {/* <li className=" focus:ring-gray-50 dark:focus:ring-gray-0 text-customgreen ">
                          {' '}
                          {isAdmin && (
                            <Link className="hover:text-customgreen" to={'/SDManageList'} onClick={handleCloseClick}>
                              {t('Manage List')}
                            </Link>
                          )}
                        </li> */}
                        <li className="accordion-children focus:ring-gray-50 dark:focus:ring-gray-0 text-customgreen ">
                          {' '}
                          {isAdmin && (
                            <Link className="hover:text-customgreen" to={'/SDReportList'} onClick={handleCloseClick}>
                              {t('Service For Dead Report List')}
                            </Link>
                          )}
                        </li>
                      </ul>
                    </Accordion.Content>
                  </AccordionPanel>

                  <AccordionPanel>
                    <Accordion.Title className="accordion-heading hover:text-customgreen dark:divide-gray-0 p-2 divide-y-0 divide-gray-0 focus:ring-gray-50 dark:focus:ring-gray-0 text-customgreen ">
                      {t('Idea Suggestion')}
                    </Accordion.Title>
                    <Accordion.Content className="p-2 bg-white text-center">
                      <ul  className={`${isActive ? 'text-right' : 'text-left'}  `}>
                        <li className="accordion-children focus:ring-gray-50 dark:focus:ring-gray-0 text-customgreen ">
                          {isAdmin && (
                            <Link
                              className="hover:text-customgreen"
                              to={'/IdeaSuggestionList'}
                              onClick={handleCloseClick}
                            >
                              {t('Idea Suggestion List')}
                            </Link>
                          )}
                        </li>
                      </ul>
                    </Accordion.Content>
                  </AccordionPanel>

                  <AccordionPanel>
                    <Accordion.Title className="accordion-heading hover:text-customgreen dark:divide-gray-0 p-2 divide-y-0 divide-gray-0 focus:ring-gray-50 dark:focus:ring-gray-0 text-customgreen ">
                      {t('Service For Gift')}
                    </Accordion.Title>
                    <Accordion.Content className="p-2 bg-white text-center">
                      <ul  className={`${isActive ? 'text-right' : 'text-left'}  `}>
                        <li className="accordion-children focus:ring-gray-50 dark:focus:ring-gray-0 text-customgreen ">
                          {isAdmin && (
                            <Link className="hover:text-customgreen" to={'/gifts'} onClick={handleCloseClick}>
                              {t('Gift Service List')}
                            </Link>
                          )}
                        </li>
                      </ul>
                    </Accordion.Content>
                  </AccordionPanel>

                  <Accordion.Panel>
                    {isAuthenticated && (
                      <>
                        {navLinksData.map(
                          (el, i) =>
                            el.children && (
                              <div key={i}>
                                <Accordion.Title className=" accordion-heading dark:divide-gray-0 p-2 divide-y-0 divide-gray-0 focus:ring-gray-50 dark:focus:ring-gray-0 text-customgreen">
                                  {t(`${el.name}`)}
                                </Accordion.Title>
                                <ul  >
                                  {el?.children?.map((ele, index) =>
                                    isAdmin === ele?.isAdmin && !ele?.ishidden ? (
                                      <li className="text-customgreen p-0 "  key={index}>
                                        <Accordion.Content className="p-0 accordion-children bg-white text-center" >
                                          <Link
                                             className="hover:text-customgreen"
                                            
                                            to={ele.link}
                                            onClick={handleCloseClick}
                                          >
                                            <div className={`${isActive ? 'text-right' : 'text-left'}  `}>
                                            {t(`${ele.name}`)}
                                            </div>
                                          
                                          </Link>
                                        </Accordion.Content>
                                      </li>
                                    ) : null,
                                  )}
                                </ul>
                              </div>
                            ),
                        )}
                      </>
                    )}
                  </Accordion.Panel>

                  <AccordionPanel className="">
                    <Accordion.Title className="accordion-heading hover:text-customgreen dark:divide-gray-0 p-2 divide-y-0 divide-gray-0 focus:ring-gray-50 dark:focus:ring-gray-0 text-customgreen ">
                      {t('Reports')}
                    </Accordion.Title>
                    <Accordion.Content className="p-2 bg-white text-center">
                      <ul  className={`${isActive ? 'text-right' : 'text-left'}  `}>
                        <li className="accordion-children focus:ring-gray-50 dark:focus:ring-gray-0 text-customgreen ">
                          {isAdmin && (
                            <Link
                              className="hover:text-customgreen"
                              onClick={handleCloseClick}
                              to={'/GetSDReportFilterList'}
                            >
                              {t('SD Report')}
                            </Link>
                          )}
                        </li>
                        <li className="accordion-children focus:ring-gray-50 dark:focus:ring-gray-0 text-customgreen ">
                          {isAdmin && (
                            <Link
                              className="hover:text-customgreen"
                              onClick={handleCloseClick}
                              to={'/GetGWAReportFilterList'}
                            >
                              {t('GWA Report')}
                            </Link>
                          )}
                        </li>
                        <li className="accordion-children focus:ring-gray-50 dark:focus:ring-gray-0 text-customgreen ">
                          {isAdmin && (
                            <Link
                              className="hover:text-customgreen"
                              onClick={handleCloseClick}
                              to={'/GetGWAServiceReportFilterList'}
                            >
                              {t('GWA Service Report')}
                            </Link>
                          )}
                        </li>
                        <li className="accordion-children focus:ring-gray-50 dark:focus:ring-gray-0 text-customgreen ">
                          {isAdmin && (
                            <Link
                              className="hover:text-customgreen"
                              onClick={handleCloseClick}
                              to={'/GetCampaignReportFilterList'}
                            >
                              {t('Campaign Report')}
                            </Link>
                          )}
                        </li>
                        <li className="accordion-children focus:ring-gray-50 dark:focus:ring-gray-0 text-customgreen ">
                          {isAdmin && (
                            <Link
                              className="hover:text-customgreen"
                              onClick={handleCloseClick}
                              to={'/GetServiceForYouReportFilterList'}
                            >
                              {t('Service You Report')}
                            </Link>
                          )}
                        </li>
                        <li className="accordion-children focus:ring-gray-50 dark:focus:ring-gray-0 text-customgreen ">
                          {isAdmin && (
                            <Link
                              className="hover:text-customgreen"
                              onClick={handleCloseClick}
                              to={'/LoginLogsReportList'}
                            >
                              {t('Login Logs Report')}
                            </Link>
                          )}
                        </li>
                        <li className="accordion-children focus:ring-gray-50 dark:focus:ring-gray-0 text-customgreen ">
                          {isAdmin && (
                            <Link
                              className="hover:text-customgreen"
                              onClick={handleCloseClick}
                              to={'/EPVolunteerReportList'}
                            >
                              {t('Volunteer Report List')}
                            </Link>
                          )}
                        </li>
                        <li className="accordion-children focus:ring-gray-50 dark:focus:ring-gray-0 text-customgreen ">
                          {isAdmin && (
                            <Link
                              className="hover:text-customgreen"
                              onClick={handleCloseClick}
                              to={'/EPUserReportList'}
                            >
                              {t('User Profile Report List')}
                            </Link>
                          )}
                        </li>
                        <li className="accordion-children focus:ring-gray-50 dark:focus:ring-gray-0 text-customgreen ">
                          {isAdmin && (
                            <Link className="hover:text-customgreen" onClick={handleCloseClick} to={'/PaymentReport'}>
                              {t('Donation Report')}
                            </Link>
                          )}
                        </li>
                      </ul>
                    </Accordion.Content>
                  </AccordionPanel>
                </Accordion>
              </ul>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default AdminMenu;
